module.exports = __webpack_public_path__ + "img/img_14.735f0ce0.jpg";